export default __webpack_public_path__ + "static/media/cta_checkmark.cc34e2da.svg";